import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Typography, Box, TextField, Button, Modal, Autocomplete } from "@mui/material";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { createEffect, createStore } from "effector";
import api from "../../Auth/api";
import { useStore } from "effector-react";
import { $userSearch, searchUserFx } from "../../Api/userSearch";
import { useForm } from "react-hook-form";
import debounce from "lodash/debounce";
import { updateModal } from "../ErrorModal";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 2,
  p: 2,
};

export const $departmentTable = createStore(null);

export const getDepartmentTableFx = createEffect(async () => {
  const response = api.get(`paid-service/department-list`);
  return response;
});

$departmentTable.on(getDepartmentTableFx, (state) => {
  return {
    ...state,
  };
});

$departmentTable.on(getDepartmentTableFx.done, (state, { result }) => {
  return {
    ...state,
    data: result.data.data,
  };
});

$departmentTable.on(getDepartmentTableFx.fail, (state) => {
  return {
    ...state,
  };
});

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function DepartmentTable() {
  const departmentTable = useStore($departmentTable);
  const [open, setOpen] = React.useState(false);
  const [openDeleteModal, setOpenDeleteModal] = React.useState(false);
  const [responsible, setResponsible] = React.useState();
  const [departmentToDelete, setDepartmentToDelete] = React.useState();
  const [id, setId] = React.useState("");
  const [name, setName] = React.useState("");
  const usersTable = useStore($userSearch);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const handleCloseUpdateModal = () => setOpen(false);
  const handleOpenUpdateModal = (row) => {
    setResponsible(row?.responsibleUser ? row?.responsibleUser : undefined);
    setId(row.id);
    setName(row.name);
    setOpen(true);
  };
  const handleOpenDeleteModal = (id) => {
    setDepartmentToDelete(id);
    setOpenDeleteModal(true);
  };
  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    setDepartmentToDelete();
  };
  const handleNameChange = (event) => {
    setName(event.target.value);
  };
  const updateDepartmentFx = createEffect(async (value) => {
    api
      .post(`/paid-service/department-update`, value)
      .then(
        () => getDepartmentTableFx(),
        (error) => updateModal(error.response.data.errors)
      )
      .then(() => handleCloseUpdateModal());
  });
  const deleteDepartmentFx = createEffect(async (id) => {
    api
      .delete(`/paid-service/department`, {
        data: {
          id: id,
        },
      })
      .then(
        () => getDepartmentTableFx(),
        (error) => updateModal(error.response.data.errors)
      )
      .then(() => handleCloseDeleteModal());
  });
  const searchUser = React.useCallback(
    debounce((event, value) => {
      searchUserFx(value);
    }, 200),
    []
  );
  const onUpdateFormSubmit = () => {
    let data = {
      id: id,
      name: name,
      responsibleUserId: responsible?.id,
    };
    updateDepartmentFx(data);
  };
  const loading = usersTable.length === 0;
  React.useEffect(() => {
    getDepartmentTableFx();
  }, []);
  return (
    <>
      <TableContainer component={Paper} sx={{ border: "1px solid #e6e6e6", boxShadow: 0 }}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                №
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Название отдела
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center">
                Ответственный
              </TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center"></TableCell>
              <TableCell sx={{ fontWeight: 600 }} align="center"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {departmentTable?.data?.length > 0 &&
              departmentTable?.data.map((row) => (
                <>
                  <StyledTableRow key={row.id}>
                    <TableCell align="center">{row.id}</TableCell>
                    <TableCell align="center">{row.name}</TableCell>
                    <TableCell align="center">{row.responsibleUser?.name}</TableCell>
                    <TableCell align="center">
                      <Button onClick={() => handleOpenUpdateModal(row)}>Редактировать</Button>
                    </TableCell>
                    <TableCell align="center">
                      <Button onClick={() => handleOpenDeleteModal(row?.id)}>Удалить</Button>
                    </TableCell>
                  </StyledTableRow>
                </>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Modal open={openDeleteModal} onClose={handleCloseDeleteModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <Box sx={style}>
          <Box display="flex" justifyContent="center">
            <Typography id="modal-modal-title" variant="h6" fontWeight={600}>
              Вы точно хотите удалить отдел?
            </Typography>
          </Box>
          <Box mt={2} width="100%" display="flex" gap={3} justifyContent="center">
            <Button variant="outlined" onClick={handleCloseDeleteModal}>
              Нет
            </Button>
            <Button variant="contained" onClick={() => deleteDepartmentFx(departmentToDelete)}>
              Да
            </Button>
          </Box>
        </Box>
      </Modal>
      <Modal open={open} onClose={handleCloseUpdateModal} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
        <form onSubmit={handleSubmit(onUpdateFormSubmit)}>
          <Box sx={style}>
            <Typography mb={3} id="modal-modal-title" variant="h6" fontWeight={600}>
              Отдел
            </Typography>
            <Box display="flex" alignItems="center">
              <Typography width={150} mb={1} variant="subtitle1" fontWeight={600}>
                Отдел:
              </Typography>
              <Box display="flex" gap={0.5} flexDirection="column">
                <TextField id="outlined-basic" label="Название" variant="outlined" sx={{ width: 260 }} value={name} {...register("department", { required: true })} onChange={handleNameChange} />
                {errors.department && <span style={{ width: "200px" }}>Поле обязательно для заполнения</span>}
              </Box>
            </Box>
            <Box display="flex" flexDirection="row" alignItems="center" mt={2}>
              <Typography width={150} mb={1} variant="subtitle1" fontWeight={600}>
                Ответственный:
              </Typography>
              <Box width="260px" display="flex" gap={0.5} flexDirection="column">
                <Autocomplete
                  id="tags-standard"
                  options={usersTable}
                  loading={loading}
                  loadingText="Загрузка..."
                  onInputChange={searchUser}
                  value={responsible}
                  onChange={(event, value) => setResponsible(value)}
                  getOptionLabel={(option) => option?.name}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  renderInput={(params) => <TextField {...params} defaultValue="  " {...register("users", { required: true })} />}
                />
                {errors.users && <span>Поле обязательно для заполнения</span>}
              </Box>
            </Box>
            <Box mt={3} width="100%" display="flex" gap={3} justifyContent="flex-end">
              <Button variant="outlined" onClick={handleCloseUpdateModal}>
                Отмена
              </Button>
              <Button type="submit" variant="contained">
                Сохранить
              </Button>
            </Box>
          </Box>
        </form>
      </Modal>
    </>
  );
}
